<template>
	<div>
		<div class="actDiv">
			<label>小区</label>
			<a-select  style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="queryParam.neighborId" placeholder="请选择小区"
						    option-filter-prop="children"  :filter-option="filterOption" show-search allowClear>
				<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
			</a-select>
			<label>采集器地址</label>
			<a-input style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="queryParam.collectorAddr"/>
			<label>IMEI</label>
			<a-input style="width:12rem; margin: 0 0.625rem;font-size: 0.6875rem;" v-model="queryParam.imei"/>
			<a-button size="small"   icon="search" @click="doQuery">查询</a-button>
			<a-button size="small"   icon="plus" type="primary" @click="showAddFlag = true" style="margin-left: 0.625rem;">新增</a-button>
			<a-button size="small"   icon="download" @click="exportNBCollector" style="margin-left: 0.625rem;">导出</a-button>
		</div>
		<vxe-table  align="center" :data="list"  border max-height="600"   ref="mTable"
						  resizable highlight-hover-row :loading="loading" size="mini">
			<vxe-table-column type="seq" width="50"></vxe-table-column>
			<vxe-table-column title="小区" field="neighborId"   :formatter="getNeighborName"></vxe-table-column>
			<vxe-table-column title="平台" field="platform"   :formatter="getPlatform"></vxe-table-column>
			<vxe-table-column title="采集器地址" field="collectorAddr"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="IMEI" field="imei" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="IMSI" field="imsi" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="电压" field="voltage"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="采集间隔" field="acquInterval"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="信号指示" field="csq" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="信号强度" field="rsrp" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="信号质量" field="rsrq" show-overflow="title"></vxe-table-column>
			<vxe-table-column title="信噪比" field="snr"  show-overflow="title"></vxe-table-column>
			<vxe-table-column title="数据上报时间" field="updateTime" show-overflow="title" width="160"></vxe-table-column>
			<vxe-table-column title="操作" field="id" width="360">
				<template #default="{ row }">
					<a-button size="small"  type="link" @click="showUpdateView(row)">修改</a-button>
					<a-popconfirm title="确定要删除该条记录?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="deleteContent(row)">
						<a-button size="small"  type="link">删除</a-button>
					</a-popconfirm>
					<a-button size="small"  type="link" @click="setupWorkMode(row)">设置工作模式</a-button>
					<a-button size="small"  type="link" @click="setupUploadDate(row)">设置上报日期</a-button>
					<a-popconfirm title="确定要更新地址池?" ok-text="确定" cancel-text="取消" placement="bottom" @confirm="dispatchAddr(row)">
						<a-button size="small"  type="link">下发地址</a-button>
					</a-popconfirm>
					<a-button size="small"  type="link" @click="showDeleteCommandView(row)">删除指令</a-button>
				</template>
			</vxe-table-column>
		</vxe-table>
		<a-drawer title="新增NB采集器" :visible="showAddFlag"  width="540" @close="showAddFlag = false" :destroyOnClose='true' :maskClosable="false">
			<AddNewNBCollector :neighborList="neighborList" @cancelAdd="closeAddView" @refreshList="doQuery"/>
		</a-drawer>
		<a-drawer title="修改NB采集器" :visible="showEditFlag"  width="540" @close="showEditFlag = false" :destroyOnClose='true' :maskClosable="false">
			<EditNBCollector :neighborList="neighborList" :editObj="theEditObj"  @cancelEdit="closeEditView" @refreshList="doQuery"/>
		</a-drawer>
		<a-modal title="设置工作模式"  :visible="showWorkModeFlag"  @ok="sendWorkModeCommand" @cancel="closeSetupView" :dialog-style="{ top: '20px' }"
					cancel-text="取消" ok-text="提交" :destroyOnClose = "true">
			<a-form-model   :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
				<a-form-model-item label="操作密码" >
					<a-input  v-model="actionPwd" style="width: 12rem;" @input="checkActionPwd"/>
				</a-form-model-item>
				<a-form-model-item v-if ="showSetupFlag" label="工作模式" >
					<a-radio-group v-model:value="workMode">
						<a-radio value="1">PDM</a-radio>
						<a-radio value="2">PSM</a-radio>
					</a-radio-group>
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<a-modal title="设置上传日期"  :visible="showUploadDateFlag"  @ok="sendUploadDateCommand" @cancel="closeSetupView" :dialog-style="{ top: '20px' }"
					cancel-text="取消" ok-text="提交" :destroyOnClose = "true">
			<a-form-model   :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }" >
				<a-form-model-item label="操作密码" >
					<a-input  v-model="actionPwd" style="width: 12rem;" @input="checkActionPwd"/>
				</a-form-model-item>
				<a-form-model-item v-if ="showSetupFlag" label="上传日期">
					<a-checkbox v-model:checked="checkAll" :indeterminate="indeterminate" @change="onCheckAllChange">
						全选
					</a-checkbox>
					<a-checkbox-group v-model:value="checkedList" name="checkboxgroup" :options="plainOptions"/>
				</a-form-model-item>
				<a-form-model-item v-if ="showSetupFlag" label="上传时辰">
					<a-select   v-model:value="theHour" style="width: 12.5rem;">
						<a-select-option v-for="(item,index) in hourList" :key="item" :value="item">
							{{item}}
						</a-select-option>
					</a-select>
					时
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<DeleteNBCommandView ref="deleteCommandView"/>
	</div>
</template>

<script>
	import AddNewNBCollector from '../components/AddNewNBCollector.vue'
	import EditNBCollector from '../components/EditNBCollector.vue'
	import DeleteNBCommandView from '../components/DeleteNBCommandView.vue'
	export default {
		components:{
			AddNewNBCollector,
			EditNBCollector,
			DeleteNBCommandView,
		},
		data(){
			return {
				theHour:"1",
				checkAll:false,
				checkedList:[],
				indeterminate:false,
				loading:false,
				queryParam:{
					neighborId:null,
					collectorAddr:null,
					imei:null,
				},
				list:[],
				neighborList:[],
				showAddFlag:false,
				showEditFlag:false,
				showWorkModeFlag:false,
				showUploadDateFlag:false,
				showSetupFlag:false,
				theEditObj:{},
				actionPwd:null,
				workMode:"1",
				plainOptions:["1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29","30","31"],
				hourList:["0","1","2","3","4","5","6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23"],
			}
		},
		methods:{
			exportNBCollector(){
				let url = this.Api.getLastUrl(this.Api.EXPORT_NB_COLLECTOR_URL);
				this.Api.fetchPostFile(url,this.queryParam).then((res)=>{
					let blob = new Blob([res.data]);
					let downloadElement = document.createElement('a')
					let href = window.URL.createObjectURL(blob); //创建下载的链接
					downloadElement.href = href;
					let fileName = 'NB采集器.xlsx';
					downloadElement.download = fileName; //下载后文件名
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放blob对象
				}).catch((error)=>{
					console.log(error);
				});
			},
			sendUploadDateCommand:function(){
				let temp = this.Config.deepClone(this.checkedList);
				temp.push(this.theHour);
				let param = {
					uploadDate:temp.join(","),
					collectorAddr:this.theEditObj.collectorAddr
				};
				let url = this.Api.getLastUrl(this.Api.SEND_SETUP_UPLOAD_DATE_COMMAND_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("设置上传日期指令下发成功");
						this.closeSetupView();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			setupUploadDate(row){
				this.theEditObj = row;
				this.showUploadDateFlag = true;
			},
			onCheckAllChange(e){
				if(e.target.checked){
					this.checkedList =this.plainOptions;
				}else{
					this.checkedList = [];
				}
				this.indeterminate = false;
			},
			sendWorkModeCommand(){
				let url = this.Api.getLastUrl(this.Api.SEND_SETUP_WORK_MODE_COMMAND_URL);
				let param = {
					workMode:this.workMode,
					collectorAddr:this.theEditObj.collectorAddr
				}
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("设置工作模式指令下发成功");
						this.closeSetupView();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			setupWorkMode(row){
				this.theEditObj = row;
				this.showWorkModeFlag = true;
			},
			checkActionPwd(value){
				if(this.actionPwd == this.Config.ACTION_PWD){
					this.showSetupFlag = true;
				}else{
					this.showSetupFlag = false;
				}
			},
			closeSetupView(){
					this.showWorkModeFlag = false;
					this.showUploadDateFlag = false;
					this.showSetupFlag = false;
					this.actionPwd = null;
					this.uploadDate = null;
			},
			showUpdateView(row){
				this.theEditObj = this.Config.deepClone(row);
				this.showEditFlag = true;
			},
			dispatchAddr:function(item){
				let param = {collectorAddr:item.collectorAddr};
				let url = this.Api.getLastUrl(this.Api.DISPATCH_ADDR_NB_COLLECTOR_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('下发地址指令已创建');
						this.doQuery();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			deleteCommand:function(item){
				let param = {collectorAddr:item.collectorAddr};
				let url = this.Api.getLastUrl(this.Api.DELETE_NB_COLLECTOR_COMMAND_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.doQuery();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			deleteContent:function(item){
				let param = {theId:item.id};
				let url = this.Api.getLastUrl(this.Api.DELETE_NB_COLLECTOR_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.doQuery();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			closeAddView(){
				this.showAddFlag = false;
			},
			closeEditView(){
				this.showEditFlag = false;
			},
			getPlatform({cellValue}){
				if(cellValue == '0'){
					return "AEP";
				}else{
					return "OneNet";
				}
			},
			getNeighborName({cellValue}){
				let result = null;
				for(var i=0;i<this.neighborList.length;i++){
					let item = this.neighborList[i];
					if(item.pId == cellValue){
						result =  item.neighborName;
						break;
					}
				}
				return result;
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			queryNeighbors:function(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_SEARCH_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
						this.doQuery();
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			showDeleteCommandView(row){
				this.$refs.deleteCommandView.showView(row);
			},
			doQuery(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.GET_NB_COLLECTOR_LIST_URL);
				this.Api.fetchPostWithForm(url,this.queryParam).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
					this.loading = false;
				});
			},
		},
		watch:{
			"checkedList"(newVal,oldVal){
				this.indeterminate = !!newVal.length && newVal.length < this.plainOptions.length;
				this.checkAll = newVal.length === this.plainOptions.length;
			}
		},
		created() {
			this.queryNeighbors();
		}
		
	}
</script>

<style>
</style>
